import { Link } from "react-router-dom";
import { useState } from "react";
import api from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import { toast } from "sonner";
import { Headphones, Linkedin, Youtube, Music2, MessageCircle, Send } from "lucide-react";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const { settings } = useSettings();
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); toast.success("Iscrizione completata!"); setEmail(""); }
    catch { toast.error("Errore, riprova."); }
  };

  const social = settings?.social || {};
  const messaging = settings?.messaging || {};
  const waLink = messaging.whatsapp ? `https://wa.me/${messaging.whatsapp.replace(/[^0-9]/g, "")}` : "";
  const tgLink = messaging.telegram ? `https://t.me/${messaging.telegram.replace(/^@/, "")}` : "";
  const socials = [
    { href: social.linkedin, icon: Linkedin },
    { href: social.spotify, icon: Music2 },
    { href: social.youtube, icon: Youtube },
    { href: waLink, icon: MessageCircle },
    { href: tgLink, icon: Send },
  ].filter((s) => s.href);

  return (
    <footer className="bg-navy text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center"><Headphones className="w-5 h-5 text-gold" /></span>
            <span className="font-serif text-lg font-bold text-white">{settings?.host_name || "Enzo Lavolta"}</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">{settings?.tagline || "Le novità del diritto del lavoro, spiegate da chi le vive ogni giorno."}</p>
          <div className="flex gap-3 mt-5">
            {socials.length === 0 && <span className="text-xs text-slate-500">Collega i tuoi canali dall'area Admin</span>}
            {socials.map((s, i) => (
              <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy transition-colors">
                <s.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Naviga</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/episodi" className="hover:text-gold transition-colors">Archivio Episodi</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors">Blog & Approfondimenti</Link></li>
            <li><Link to="/abbonamenti" className="hover:text-gold transition-colors">Abbonamenti</Link></li>
            <li><Link to="/chi-sono" className="hover:text-gold transition-colors">Chi sono</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legale</h4>
          <ul className="space-y-2.5 text-sm">
            <li><a href="#" className="hover:text-gold transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-gold transition-colors">Termini di Servizio</a></li>
            <li><a href="#" className="hover:text-gold transition-colors">Cookie Policy (GDPR)</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Newsletter</h4>
          <p className="text-sm text-slate-400 mb-3">Ricevi aggiornamenti sui nuovi episodi.</p>
          <form onSubmit={submit} className="flex gap-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email"
              data-testid="footer-newsletter-input"
              className="flex-1 bg-white/10 border border-white/10 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-gold" />
            <button type="submit" data-testid="footer-newsletter-submit" className="bg-gold text-navy rounded-full px-5 py-2.5 text-sm font-semibold hover:bg-white transition-colors">Iscriviti</button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © 2026 {settings?.host_name || "Enzo Lavolta"} — Il Podcast. Tutti i diritti riservati.
      </div>
    </footer>
  );
};
